import React, { useEffect, useState } from 'react';
import RedClockIcon from '@assets/images/redClock.svg';
import YellowClockIcon from '@assets/images/yellowClock.svg';
import GreenClockIcon from '@assets/images/greenClock.svg';
import { Box } from '@mui/material';
import moment from 'moment';
import CustomTypography from '../lib/ui-components/Typography/CustomTypography';

const TimeTicker: React.FC<{
  createdOn: string | null;
  isWaitingRoom?: boolean;
}> = ({ createdOn, isWaitingRoom = false }) => {
  const [currentTimer, setCurrentTimer] = useState('');
  const [timerColor, setTimerColor] = useState('#21BB6E'); // Default color
  const [timerIcon, setTimerIcon] = useState('green');

  const calculateDifference = () => {
    if (!createdOn) {
      return { hours: 0, minutes: 0, totalMinutes: 0 };
    }

    const normalizedTime = createdOn.endsWith('Z')
      ? createdOn
      : `${createdOn}Z`;
    const giventimeToLocal = moment.utc(normalizedTime).local().valueOf();
    const currentLocalTime = moment().local().valueOf();

    const diffMilliseconds = Math.max(0, currentLocalTime - giventimeToLocal);

    const minutesPassed = Math.floor(diffMilliseconds / (1000 * 60));
    const hours = Math.floor(minutesPassed / 60);
    const minutes = minutesPassed % 60;

    return { hours, minutes, totalMinutes: minutesPassed };
  };

  const startTimer = () => {
    const { hours, minutes, totalMinutes } = calculateDifference();

    // Set the timer color based on the total minutes passed
    if (totalMinutes < 90) {
      setTimerColor('#21BB6E');
      setTimerIcon('green');
    } else if (totalMinutes >= 90 && totalMinutes < 180) {
      setTimerColor('#E1A500');
      setTimerIcon('yellow');
    } else {
      setTimerColor('#EB4C60');
      setTimerIcon('red');
    }

    setCurrentTimer(
      isWaitingRoom
        ? `${String(hours).padStart(2, '0')}h:${String(minutes).padStart(2, '0')}m`
        : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
    );
  };

  useEffect(() => {
    startTimer(); // Calculate the difference and update color immediately

    const interval = setInterval(() => {
      startTimer();
    }, 60000); // Increment minute-wise

    return () => clearInterval(interval); // Cleanup on unmount
  }, [createdOn]);

  let clockIcon;
  if (timerIcon === 'red') {
    clockIcon = <RedClockIcon />;
  } else if (timerIcon === 'yellow') {
    clockIcon = <YellowClockIcon />;
  } else {
    clockIcon = <GreenClockIcon />;
  }

  if (isWaitingRoom) {
    return <>{currentTimer}</>;
  }
  return (
    <Box
      style={
        {
          display: 'flex',
          gap: '4px',
          '--timer-color': timerColor,
        } as React.CSSProperties
      }
    >
      {currentTimer && clockIcon}

      <CustomTypography variant="body2" id="waitingTimeTick">
        {/* Pass color to the ClockIcon */}
        <span style={{ color: timerColor }}>{currentTimer}</span>
      </CustomTypography>
    </Box>
  );
};

export default TimeTicker;
